// Velocidades em pixels por segundo
const PIXELS_PER_SECOND = {
  0.5: 30, // Lento - 30px/s
  1: 60, // Normal - 60px/s
  1.5: 90, // Rápido - 90px/s
  2: 120, // Muito rápido - 120px/s
};

const state = {
  selectedSpeed: parseFloat(localStorage.getItem("autoScrollSpeed")) || 1,
  settingsDialog: false,
  isScrolling: false,
  isPaused: false,
};

const mutations = {
  setSelectedSpeed(state, value) {
    state.selectedSpeed = value;
    localStorage.setItem("autoScrollSpeed", value);
  },
  setSettingsDialog(state, value) {
    state.settingsDialog = value;
  },
  setIsScrolling(state, value) {
    state.isScrolling = value;
  },
  setIsPaused(state, value) {
    state.isPaused = value;
  },
};

const actions = {};

const getters = {
  // Pixels por segundo baseado na velocidade selecionada
  pixelsPerSecond(state) {
    return PIXELS_PER_SECOND[state.selectedSpeed] || 60;
  },
  // Pixels por frame (assumindo 60fps)
  pixelsPerFrame(state, getters) {
    return getters.pixelsPerSecond / 60;
  },
  // Duração estimada em milissegundos (compatibilidade com código antigo)
  duration(state, getters) {
    if (typeof document === "undefined") return 0;
    const pageHeight = document.body.scrollHeight - window.innerHeight;
    const seconds = pageHeight / getters.pixelsPerSecond;
    return seconds * 1000;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true,
};
